import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import screenshots from "../assets/screenshots";

function Features() {
  const { t, locale } = useLanguage();

  return (
    <section id="features" className="story-section story-section--reverse">
      <div className="story-content">
        <div className="story-tag">{t.scan.tag}</div>
        <h2>{t.scan.title}</h2>
        <p>{t.scan.description}</p>
        <ul className="story-bullets">
          {t.scan.bullets.map((bullet) => (
            <li key={bullet}>{bullet}</li>
          ))}
        </ul>
        <div className="story-result">
          <div>
            <strong>{t.scan.resultLabel}</strong>
            <p>{t.scan.result}</p>
          </div>
        </div>
      </div>

      <div className="story-visual">
        <div className="phone-mockup">
          <img
            src={screenshots[locale].aiScan}
            alt={t.scan.mockupAlt}
            className="screen-shot"
          />
        </div>
      </div>
    </section>
  );
}

export default Features;
